import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

import '../styles/recipientSelect.scss';

export default class RecipientSelect extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      tempEmail: ''
    };
  }

  validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  buildContactsList() {
    const contacts = this.props.contacts || [];
    const contactsList = contacts.map((c) => c.email);
    const tempEmails = this.props.selectedRecipients?.filter((r) => !contactsList.includes(r));
    return contacts.concat(tempEmails?.map((r) => ({ email: r })) || []);
  }

  addTempEmail = async () => {
    const email = this.state.tempEmail.trim();
    if (!this.validateEmail(email)) return;
    await this.props.addNewContact(email);
    this.setState({ tempEmail: '' });
  }

  handleBackdropClick = async (e) => {
    e.stopPropagation();
    if (this.validateEmail(this.state.tempEmail.trim())) {
      await this.addTempEmail();
    } else {
      this.setState({ tempEmail: '' });
      this.props.close();
    }
  }

  handleContinue = async () => {
    if (this.validateEmail(this.state.tempEmail.trim())) {
      await this.props.addNewContact(this.state.tempEmail.trim());
    }
    this.props.submit();
    this.setState({ tempEmail: '' });
  }

  render() {
    const contacts = this.buildContactsList().filter(Boolean);
    const selectedCount = this.props.selectedRecipients?.length || 0;
    const canAdd = this.validateEmail(this.state.tempEmail.trim());

    return (
      <div className="recipient-select-backdrop" onClick={this.handleBackdropClick}>
        <div className="recipient-select" onClick={(e) => e.stopPropagation()}>
          <header className="recipient-select-header">
            <h2 className="recipient-select-title">{this.props.title || 'Report Recipients'}</h2>
            <p className="recipient-select-meta">
              {selectedCount === 0
                ? 'None selected'
                : `${selectedCount} selected`}
            </p>
          </header>

          <div className="recipient-select-body">
            {contacts.length > 0 ? (
              <ul className="recipient-select-list">
                {contacts.map((contact) => {
                  const selected = this.props.selectedRecipients?.includes(contact.email);
                  const name = [contact.fname, contact.lname].filter(Boolean).join(' ');
                  return (
                    <li key={contact.email}>
                      <button
                        type="button"
                        className={`recipient-select-row${selected ? ' selected' : ''}`}
                        onClick={() => this.props.handleRecipientSelect(contact.email)}
                      >
                        <span className={`recipient-select-check${selected ? ' on' : ''}`}>
                          {selected && <CheckIcon />}
                        </span>
                        <span className="recipient-select-info">
                          {name ? (
                            <span className="recipient-select-name">{name}</span>
                          ) : null}
                          <span className="recipient-select-email">{contact.email}</span>
                        </span>
                      </button>
                    </li>
                  );
                })}
              </ul>
            ) : (
              <p className="recipient-select-empty">No contacts yet — add an email below.</p>
            )}

            <div className="recipient-select-add">
              <input
                type="email"
                className="recipient-select-add-input"
                placeholder="Add email address"
                value={this.state.tempEmail}
                onChange={(e) => this.setState({ tempEmail: e.target.value })}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && canAdd) {
                    e.preventDefault();
                    this.addTempEmail();
                  }
                }}
              />
              <button
                type="button"
                className="recipient-select-add-button"
                disabled={!canAdd}
                onClick={this.addTempEmail}
                aria-label="Add email"
              >
                <AddIcon />
              </button>
            </div>
          </div>

          <footer className="recipient-select-footer">
            <button
              type="button"
              className="recipient-select-cancel"
              onClick={() => {
                this.setState({ tempEmail: '' });
                this.props.close();
              }}
            >
              <CloseIcon />
              Cancel
            </button>
            <button
              type="button"
              className="recipient-select-continue"
              onClick={this.handleContinue}
              disabled={this.props.loading}
            >
              {this.props.loading ? (this.props.loadingMessage || 'Saving…') : 'Continue'}
            </button>
          </footer>
        </div>
      </div>
    );
  }
}
